<template>
  <div>
    <vue-apex-charts
      class="d-flex justify-content-center"
      type="radialBar"
      v-bind="$attrs"
      height="180"
      width="150"
      :options="supportTrackerRadialBar.chartOptions"
      :series="supportTrackerRadialBar.series"
    />
    <div>اكتمال ملف المنظمة</div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { $themeColors } from "@themeConfig";

export default {
  components: {
    VueApexCharts,
  },
  data() {
    return {
      supportTrackerRadialBar: {
        series: [83],
        chartOptions: {
          plotOptions: {
            radialBar: {
              size: 150,
              offsetY: 0,
              startAngle: -180,
              endAngle: 180,
              hollow: {
                size: "65%",
              },
              track: {
                background: "#fff",
                strokeWidth: "100%",
              },
              dataLabels: {
                name: {
                  show: false,
                },
                value: {
                  offsetY: 10,
                  color: "#5e5873",
                  fontSize: "1.714rem",
                },
              },
            },
          },
          colors: [$themeColors.danger],
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              type: "horizontal",
              shadeIntensity: 0.5,
              gradientToColors: [$themeColors.primary],
              inverseColors: true,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100],
            },
          },
          stroke: {
            dashArray: 5,
          },
        },
      },
    };
  },
};
</script>
